import { render, staticRenderFns } from "./RedeemMyPackage.vue?vue&type=template&id=a8637e66"
import script from "./RedeemMyPackage.vue?vue&type=script&lang=js"
export * from "./RedeemMyPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports